import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { getLightBorder } from 'Components/utils';
import StatusChip from './StatusChip';
import BackButtonPicker from './BackButtonPicker';

const styles = (theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    ...getLightBorder(theme, { bottom: true }),
  },
  buttonHolder: {
    paddingRight: theme.spacing(1),
  },
  textHolder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

const Header = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.buttonHolder}>
        <BackButtonPicker />
      </div>
      <div className={classes.textHolder}>
        <Text
          text={pageContentResource.attr('proposalName')}
          variant={'h3'}
          weight={'bold'}
          color={'primary'}
        />
        <StatusChip />
      </div>
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
